import { QueryClient } from '@tanstack/react-query';
import { isUnauthenticatedError } from 'src/services/authToken';

/**
 * App-wide QueryClient.
 *
 * Lives in its own module (it used to be a local const in `App.tsx`) so that
 * code outside the React tree — above all `logout()` — can cancel the running
 * queries and clear the cache of the user who is signing out. Without that, the
 * next user gets the previous user's cached access rights served synchronously
 * on first render.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // react-query's default is `retry: 3`; keep that, but never retry a
      // request the auth middleware short-circuited for lack of a token —
      // retrying cannot produce a token, it only produces noise.
      retry: (failureCount, error) => !isUnauthenticatedError(error) && failureCount < 3,
    },
  },
});

export default queryClient;
